<template>
    <div class="mb-4 jewelry_block col-lg-3 col-md-4 col-6" :class="{ 'col-lg-12 col-md-12 col-12 list_view mob-list-view-spacing' :viewType === 'list'}">
      
       <div class="" v-if="data.key === 'empty_state'">
            <img src="@/assets/assets/skeleton.jpg" width="600" height="600" alt="loading skeleton">
            <p class="placeholder-glow mb-0 mt-2">
                <span class="placeholder col-12 p-3"></span>
                <span class="placeholder col-6 p-2 my-2"></span>
            </p>
            <p class="placeholder-glow mb-0">
                <span class="placeholder col-1 p-3 me-1"></span>
                <span class="placeholder col-1 p-3 me-1"></span>
                <span class="placeholder col-1 p-3 me-1"> </span>
            </p>
        </div>
        <div class="product_box" v-if="currentMetal" >
            <div class="disc_chip_plp" v-if="!$country.is_india && currentMetal.discount_label">{{ currentMetal.discount_label }}% OFF</div>
            <div class="product-sku">{{ data.main_sku }}</div>
            <router-link :to="localePath(currentPath(currentMetal.slug))" class="for_desktop on_hover min_height">
                <!-- <div class="rec_box">Best Seller</div> -->
                <img loading="lazy" v-if="loader" width="246" class="loader_img" height="246" alt="loader" src="~/assets/assets/loader.svg">
                
                <div v-show="!loader" class="product_img_hover">
                    <img class="front_img" width="246" height="246" :src="currentMetal.images.front" :alt="data.product_name + ' front view'">
                    <img loading="lazy" class="left_img" width="246" height="246" :src="currentMetal.images.left" :alt="data.product_name + ' top view'">
                </div>
                
            </router-link>
            <div class="for_mobile min_height " @click="openQuickView()">
                <img loading="lazy" v-if="loader" width="246" class="loader_img" height="246" alt="loader" src="~/assets/assets/loader.svg">
                
                <div v-show="!loader">
                    <img class="front_img w-100" width="246" height="246" :src="currentMetal.images.front" :alt="data.product_name + ' front view'">
                </div>
            </div>

            <h5 :class="{'show': type === 'cyor' && data.has_accent_stones === 1}" class="mb-0">Hidden Accents</h5>
            <h3 class="mb-0" :class="{'grid_view_mob_fs':viewType !== 'list'}">{{data.product_name}}</h3>
            
             <!-- :class="{'price-min-height mb-0': !$country.is_india }" -->
            <h4 class="mb-3" >
                {{ $formatPrice(currentMetal.price) }}
                <!-- discount_label -->
                <span v-if="!$country.is_india && currentMetal?.discount_label">{{ $formatPrice(currentMetal.mrp) }}</span>
                <!-- lowest_price_label  -->
                <span v-if="!$country.is_india && currentMetal?.discount_label && currentMetal?.lowest_price_label" class="lowest_price_plp mt-2">Lowest Price Ever</span>
            </h4>
        
            
            <div class="metal_color d-flex mb-2 pb-1 align-items-center"  >
                <div 
                    v-for="metal in metalList" 
                    :key="metal.slug"
                    class="metal_box"
                    @click="selectMetal(metal.metal)"
                    :class="{ 
                        'white': (metal.metal === 4 || metal.metal === 7 || metal.metal === 10 ), 
                        'yellow': (metal.metal === 5 || metal.metal === 8), 
                        'rose': (metal.metal === 6 || metal.metal === 9),
                        'active': metal.selected === 1
                    }"
                    >
                </div>
            </div>
            <p v-show="type === 'cyor' && data.matchingBand === 1" class="mb-0">Matching band available</p>
        </div> 
    </div>
</template>

<script setup>
    const { data, type, viewType } = defineProps(['data', 'type', 'viewType'])
    const emits = defineEmits(['openQuickView'])
    const localePath = useLocalePath()
    const { $formatPrice, $country } = useNuxtApp()

    import { cyolistStore }  from '@/stores/cyolist/cyolist';
    const store = cyolistStore();
    const route = useRoute();
    const router = useRouter();

    
    const moduleType = route.meta.moduleType
    const moduleSubType = route.meta.moduleSubType 

    const loader = ref(false)

    function openQuickView(){
        emits('openQuickView',data)
    }
    
    const selectedMetal = computed(() =>{
        const metalList = store.getSettingFilterOptions( moduleSubType , 'metal' )
        if( metalList && metalList.length > 0){
            return metalList.find( (cv)=>  { return cv.active === 1  })
        }
        return false
    })

    const metalList = computed(() => {
        if(selectedMetal.value){
            if(selectedMetal.value.short_label === '18K'){
                return currentMetalList.value.filter(list => list.short_label === '18k')
            }
            else if(selectedMetal.value.short_label === 'PT'){
                return currentMetalList.value.filter(list => list.short_label === 'pt')
            }
            else{
                return currentMetalList.value.filter(list => list.short_label === '14k')
            }
        }
        return currentMetalList.value.filter(list => list.short_label === '14k')
    })

    const currentMetalList = computed(() => {
       return data.metals 
    })

    const currentMetal = computed(() => {
        
        if(currentMetalList.value && currentMetalList.value.length){

            return currentMetalList.value.find((item) => item.selected === 1) 
        }
    })
  



    function currentPath(slug){

        let payload = {}

        if (moduleSubType === 'ring') {
            payload =  { name:'cyo-setting-detail-'+moduleSubType, params:{ slug: slug } }
        }

        if (moduleSubType === 'pendant') {
            payload =  { name:'cyo-setting-detail-'+moduleSubType, params:{ slug: slug } }
        }

        if (moduleSubType === 'earring') {
            payload =  { name:'cyo-setting-detail-'+moduleSubType, params:{ slug: slug } }
        }

        if(moduleSubType === 'band'){
            payload =  { name: 'shop-detail', params:{ slug: slug, type: 'womens-wedding-rings' } }
        }

        if(moduleSubType === 'couple-bands'){
            payload =  { name: 'shop-detail', params:{ slug: slug, type: 'couple-rings' } }
        }

        if(moduleSubType === 'shop-all-ring'){
            payload =  { name: 'shop-detail', params:{ slug: slug, type: 'wedding-band' } }
        }

        if ( moduleType === 'cyo' ) {

            let shape = route?.query?.Shape ? route?.query?.Shape :  'Round'

            if( import.meta.client ){

                let urlparam = new URLSearchParams(window.location.search);
                
                shape = urlparam.has("Shape") ? urlparam.get("Shape") : 'Round' ;
            }
            payload = { ...payload, ...{ query: { Shape : shape }  }}
        }
        return payload
    }

    function selectMetal(metal) {
            loader.value = true;
    
            data.metals.filter((item) =>{
                if(item.metal === metal){
                    item.selected = 1
                }else{
                    item.selected = 0
                }
            }) 
           
            setTimeout(() => {
                loader.value = false;
            }, 1000);
    }
      
    onMounted(() => {
        if( typeof cls_InovaDiamonds_Iframe !== 'undefined' && cls_InovaDiamonds_Iframe.init_Session_Go !== undefined ){
            cls_InovaDiamonds_Iframe.init_Session_Go()
        }

        if(moduleSubType === 'ring'  ){
            const script = document.createElement('script');
            script.src = 'https://vto.jewelry/?d=6LYC9UW';
            script.async = true;
            script.onload = () => {
            };
            document.head.appendChild(script);
        }
    })
</script>

<style scoped>


/* @keyframes scaleOut{
    0%{
       transform: scale(1)
    }

    100%{
        transform: scale(1.03)
    }
} */

.product-sku {
    display: none;
}
.metal_box.active {
    pointer-events: none;
}
a.on_hover {
    display: block;
}
.loader_img{
    display: block;
    width: 100%;
}

.product_box {
    padding: 15px;
    border: 1px solid #eaeaea;
    position: relative;
    border-radius: 8px;
    overflow: hidden;

}
    .product_box:hover{
        box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.15);

    }
a{
    display: inline-block;
    color: #000;
}
h3 {
    font-size: 16px;
    font-weight: normal;
    line-height: 1.5;
    min-height: 50px;
    color: #353535;
}
h4 {
    font-size: 18px;
    font-weight: 600;
    color: #668b84;
}

h4.price-min-height{
    min-height: 45px;
}
h4 span {
    color: #656565;
    text-decoration: line-through;
    /* margin-left: 10px; */
    font-weight: 400;
    font-size: 16px;
}
h4 span.india {
    display: block;
    margin-left: 0;
    font-size: 16px;
    margin-top: 5px;
}
.metal_color .metal_box {
    height: 20px;
    width: 20px;
    /* margin-right: 5px; */
    cursor: pointer;
    /* border: 2px solid #fff; */
    border-radius: 2px;
}
.metal_color .metal_box.active {
    height: 22px;
    width: 22px;
    border: 1px solid #606060;
}
.metal_color {
    gap: 8px;
}
.metal_color .yellow {
    background: #f3dda1;
}
.metal_color .rose {
    background: #f3b089;
}
.metal_color .white, .metal_color .platinum {
    background: #eff0f0;
}
p {
    color: #909090;
    font-size: 14px;
    font-weight: 300;
}
h5 {
    text-align: center;
    font-size: 12px;
    color: #909090;
    height: 20px;
    visibility: hidden;
}
h5.show{
    visibility: visible;
}
/* 
@media(min-width: 768px){
    .product_box:hover {
        border: 1px solid #eaeaea;
    }
   
} */

.rec_box {
    position: absolute;
    top: -1px;
    left: -1px;
    font-size: 12px;
    background: var(--green);
    color: #fff;
    border-radius: 3px 0 0 0;
    padding: 4px 20px 4px 10px;
    min-width: auto;
    text-align: center;
    clip-path: polygon(0 0, 100% 0%, 85% 100%, 0% 100%);
}

.front_img,.left_img,.loader_img{
    margin: auto;
}

@media(max-width: 992px){
    .product_box{
        padding: 10px;
    }
    h3{
        font-size: 14px;
    }
}
@media(max-width: 767px){
    .min_height{
        min-height: 150px;
    }
    .list_view a{
        display: block;
    }
    .list_view h3{
        text-align: center;
        min-height: auto;
    }
    .list_view h4{
        text-align: center;
    }
    .list_view .metal_color {
        justify-content: center;
    }
    .list_view p{
        text-align: center;
    }
    .jewelry_block {
        margin-bottom: 0 !important;
    }
    .jewelry_block:nth-child(2n+2) {
        /* padding: 9px 12px 9px 7px; */
        padding: 7px 12px 7px 7px;

    }
    .jewelry_block:nth-child(2n+1) {
        /* padding: 9px 7px 9px 12px; */
        padding: 7px 7px 7px 12px;

    }
    .jewelry_block.mob-list-view-spacing {
        padding: 7px 12px 7px 12px;
    }

    h4 {
        font-size: 16px;
        font-weight: 600;
        color: #668b84;
    }
    h3.grid_view_mob_fs {
        font-size: 14px;
    }

    p{
        font-size: 12px;
    }
   
    h5{
        padding: 3px 6px;
        font-size: 10px;
    }
    h4 span {
        font-size: 16px;
    }
}

</style>
